import React from 'react';

import svg from './assets/icons-32-favourite-outline.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

export const IconHeartOutlined = (props: IconProps) => (
  <SvgIcon {...props} src={svg} testId="icon-heart-outlined" />
);
